<template>
  <div class="irrigationRecordManagement-page">
    <div class="all-content-container">
      <div class="table-content-container" style="overflow: hidden">
        <div class="table-title-container">
          <div class="table-title-title" style="height: 53px">
            <h4>控制记录</h4>
            <p
              class="backBth"
              @click="canlan"
              style="line-height: 49px; cursor: pointer"
            >
              <i class="el-icon-caret-left"></i>
              <span>返回</span>
            </p>
          </div>
        </div>
        <div class="table-content">
          <div class="table-table">
            <el-table
              :data="tableData"
              style="width: 100%"
              :header-cell-style="{ background: '#f4f5f7' }"
              v-loading="loading"
            >
              <el-table-column
                prop="deviceName"
                label="设备名称"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="attributeName"
                label="属性名称"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="operation"
                label="开关操作"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="operator"
                label="操作人"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="updateTime"
                label="操作时间"
                align="center"
              ></el-table-column>
            </el-table>
          </div>
        </div>
        <div class="pagination-content-container" style="float: right">
          <el-pagination
            background
            layout="prev, pager, next,jumper"
            class="pageTap"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pagesize"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pagesize: 10,
      total: 0,
      id: "",
      hisDataIrrigationList: [],
      loading: false,
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getHisDataIrrigationList();
  },
  methods: {
    //  查询水肥一体化_灌溉记录列表
    getHisDataIrrigationList() {
      this.loading = true;
      this.$api.system
        .getHisDataIrrigationList(this.id, this.currentPage, this.pagesize)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.total = res.count;
            this.loading = false;
          } else {
            this.loading = false;
          }
        });
    },
    // 分页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getHisDataIrrigationList();
    },
    // 返回
    canlan() {
      this.$router.push({
        name: "fertilizerManagement",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/irrigationRecordManagement.scss";
</style>